import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import { staticUrl } from "../../config";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi2";
import OptimisedImage from "../../views/components/OptimisedImage";

// Defined outside the component so the reference is stable across renders,
// preventing react-slick from unmounting/remounting arrows on every re-render
// (which is a primary cause of layout shift).
const NextArrow = ({ onClick }) => (
  <div className="absolute inset-y-0 -right-10 xl:-right-16 z-10 flex items-center">
    <button
      className="text-kb-400/30 hover:text-kb-400 text-2xl xl:text-5xl focus:outline-none"
      onClick={onClick}
    >
      <HiChevronRight />
    </button>
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="absolute inset-y-0 -left-10 xl:-left-16 z-10 flex items-center">
    <button
      className="text-kb-400/30 hover:text-kb-400 text-2xl xl:text-5xl focus:outline-none"
      onClick={onClick}
    >
      <HiChevronLeft />
    </button>
  </div>
);

const HorizontalCarousel = (props) => {
  const sliderRef = useRef(null);

  let slidesToShow = 2;

  if (props.images.length > 2) {
    slidesToShow = 3;
  }

  const settings = {
    dots: false,
    fade: false,
    infinite: true,
    draggable: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 8000,
    waitForAnimate: true,
    pauseOnHover: false,
    className: "product-slider relative", // Add relative positioning to the parent container
    cssEase: "linear",
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  // Handle image click event
  const handleImageClick = (imageUrl, imageDesc) => {
    props.onImageClick(imageUrl, imageDesc);
  };

  // Generate Thumbnails
  const [images, setImages] = useState([]);

  useEffect(() => {
    const _images = props.images.map((item, index) => ({
      thumbnail: `${staticUrl}/img/media/products/product_${item}.jpg`,
      thumbnailFallback: `${staticUrl}/img/media/products/thumbnail_${item}.jpg`,
      url: `${staticUrl}/img/media/products/product_${item}.jpg`,
      description: props.descriptions[index],
    }));
    setImages(_images);
  }, [props.images]);

  return (
    <div className="flex items-center justify-center">
      <div className={`${slidesToShow === 2 ? "w-[420px]" : "w-[460px]"} px-4`}>
        <Slider ref={sliderRef} {...settings}>
          {images.map((image, index) => (
            <div
              key={index}
              className="p-4 py-6 cursor-pointer outline-none"
              onClick={() => handleImageClick(image.url, image.description)}
            >
              <OptimisedImage
                src={image.thumbnail}
                fallbackSrc={image.thumbnailFallback}
                height="600"
                width="600"
                className=""
                style={{
                  boxShadow: "0 0 18px rgba(112, 128, 144, 0.25)",
                }}
                alt={`${image.description}`}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default HorizontalCarousel;
